import { render, staticRenderFns } from "./InspectorDocument.vue?vue&type=template&id=12808ed8&"
import script from "./InspectorDocument.vue?vue&type=script&setup=true&lang=js&"
export * from "./InspectorDocument.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports